import React, { useState } from "react";
import { Flex, FlexItem } from "@chatui/core";
import { evaluate } from "../services/yoobot";
import { renderText } from '../utils/util';
import "./questionnaire.css";

const QuestionEvaluate = (props) => {
	const { serviceAvatar, appendMsg, question_id, isBanner } = props;
	const [status, setStatus] = useState(0); // 0 未评价 1 好评 2 差评
	function handleEvaluate(statusId) {
		setStatus(statusId);
		evaluate({
			is_satisfied: statusId,
			question_id,
			is_banner: isBanner ? 1 : 0
		}).then((res) => {
			if (statusId === 1) {
				appendMsg({
					type: "richText",
					content: {
						text: res.data.answer_intro,
					},
					user: { avatar: serviceAvatar },
				});
			} else {
				appendMsg({
					type: "questionnaire",
					content: {
						text: res.data.answer_intro
					},
					user: { avatar: serviceAvatar },
				});
			}
		});
	}

	if (status === 2) {
		return (
			<Flex justifyContent="flex-end" style={{ paddingBottom: "6px" }}>
				<div className={`qes_dz`}>
					<FlexItem
						flex="none"
						className={`qes_dz_item qes_dz_item_b`}
					>
						<i
							className={`iconfont icon-dianzan`}
							style={{ color: "#d7a240" }}
						></i>
						{renderText('satisfaction')}
					</FlexItem>
					<FlexItem
						flex="none"
						className={`qes_dz_item`}
						style={{ color: "#fff" }}
					>
						<i
							className={`iconfont icon-dianzan`}
							style={{
								color: "#fff",
								display: "inline-block",
								transform: "rotate(180deg)",
							}}
						></i>
						{renderText('unSatisfaction')}
					</FlexItem>
				</div>
			</Flex>
		);
	} else if (status === 1) {
		return (
			<Flex justifyContent="flex-end" style={{ paddingBottom: "6px" }}>
				<div className={`qes_dz`}>
					<FlexItem
						flex="none"
						className={`qes_dz_item qes_dz_item_b`}
						style={{ color: "#fff" }}
					>
						<i
							className={`iconfont icon-dianzan`}
							style={{ color: "#fff" }}
						></i>
						{renderText('satisfaction')}
					</FlexItem>
					<FlexItem flex="none" className={`qes_dz_item`}>
						<i
							className={`iconfont icon-dianzan`}
							style={{
								color: "#d7a240",
								display: "inline-block",
								transform: "rotate(180deg)",
							}}
						></i>
						{renderText('unSatisfaction')}
					</FlexItem>
				</div>
			</Flex>
		);
	} else {
		return (
			<Flex justifyContent="flex-end" style={{ paddingBottom: "6px" }}>
				<div className={`qes_dz`}>
					<FlexItem
						flex="none"
						className={`qes_dz_item qes_dz_item_b`}
						onClick={() => handleEvaluate(1)}
					>
						<i
							className={`iconfont icon-dianzan`}
							style={{ color: "#fce4af" }}
						></i>
						{renderText('satisfaction')}
					</FlexItem>
					<FlexItem
						flex="none"
						className={`qes_dz_item`}
						onClick={() => handleEvaluate(2)}
					>
						<i
							className={`iconfont icon-dianzan`}
							style={{
								color: "#fce4af",
								display: "inline-block",
								transform: "rotate(180deg)",
							}}
						></i>
						{renderText('unSatisfaction')}
					</FlexItem>
				</div>
			</Flex>
		);
	}
};

export default QuestionEvaluate;
